import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import {
  markAsReadAlerts,
  getAlertsDataSelector,
  getAlertErrorSelector,
  getIsFetchingAlertsSelector,
} from 'redux/reducers/alerts'
import { useShallowEqualSelector } from 'custom-hooks'

export const useAlertApi = () => {
  const dispatch = useDispatch()

  const alerts = useShallowEqualSelector(getAlertsDataSelector)
  const error = useShallowEqualSelector(getAlertErrorSelector)
  const isFetching = useShallowEqualSelector(getIsFetchingAlertsSelector)

  useEffect(() => {
    dispatch(markAsReadAlerts())
  }, [dispatch])

  return { data: alerts, error, isFetching }
}
